




























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {uuid} from 'vue-uuid'
import {namespace} from 'vuex-class';

const statistics = namespace('newstatistics')

@Component({
  name: 'DataScanStandFromTime'
})
export default class DataScanStandFromTime extends Vue {
 @Prop({type: [], default: []})  items!:any
 @Prop({type: String, default: ''})  title!:any

@statistics.Action('getScanVisitorsFormServer') protected getScanVisitorsFormServer:any

  chartItems:any =  this.items

  chartOptions = {
    chart: {
      style: {"fontSize": "12px"},
      zoomType: 'x',
      height: '505',
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '50',
      marginBottom: '50',
      colorCount: 50,
      type: 'spline',
    },

    title: {
      text: ''
    },

    subtitle: {
      text:
        document.ontouchstart === undefined
          ? this.$t('statistic.collectedDataChart.subtitle')
          : this.$t('statistic.collectedDataChart.subtitleTouched')
    },

    credits: {
      enabled: false
    },

    xAxis: {
      type: 'datetime'
    },

    yAxis: {
      title: {
        text: this.$t("newstatistics.general.scans")
      }
    },

    legend: {
      enabled: false
    },

    plotOptions: {
      line: {

      },
      series: {
        lineWidth: 3,
        lineColor:'#2D9CDB'
      },
    },
    series: [
      {
        marker: {
          lineWidth:2,
          symbol: 'circle',
          radius:3,
          enabledThreshold:2,
          fillColor:'#ffffff',
          lineColor:'#2D9CDB'
        },
        name: this.$t("newstatistics.general.scans_booth"),
        data: this.chartItems
      },

    ]
  }

  @Watch('items', {immediate: true, deep: true})
  getChartOptions(NewVal: any) {
    const ar = JSON.parse(JSON.stringify(this.items))
    this.chartItems = ar.map((ele:any)=>{
      ele[0] = ele[0]*1000
      return [ele[0], ele[1]]
    })
    this.chartOptions.series[0].data = this.chartItems
  }



}
